export const ORDER_CREATION_TIME_STATUS = {
  warning: 'warning',
  danger: 'danger',
  urgency: 'urgency',
  '': '',
} as const;

// TODO: fn type is not starting with a capital letter, why?
export type orderCreationTimeStatus = keyof typeof ORDER_CREATION_TIME_STATUS;
